module.exports = __webpack_public_path__ + "public/images/secret-image.bd2af3bdfb4379853f7bb3a011981c2b.jpg";